import React from 'react';
import { Link } from 'react-router-dom';

import PageHeader from '../../components/PageHeader.jsx';
import {
  BUSINESS_RESOURCES,
  BUSINESS_RESOURCE_ORDER,
  BUSINESS_STATIC_TILES,
} from './resources';
import { useAuth } from '../../lib/auth';
import { isSuperOnPublicSchema } from '../../config';

/**
 * Business / Organisation-Admin landing page.
 *
 * Renders one tile per resource in the registry — each tile links to
 * the resource's list page.  This is the visual equivalent of the
 * server-rendered `templates/organisational_admin/index.html`.
 */
export default function BusinessHome() {
  const { user } = useAuth();
  const publicOrg = isSuperOnPublicSchema(user);
  return (
    <>
      <PageHeader
        title="🏢 Business Settings"
        subtitle={publicOrg
          ? "Public organisation — users and structure on this host. Only super-admin can administer this organisation."
          : "Manage your organisation's structure, people, and templates."}
      />

      <div className="ty-stats" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))' }}>
        {BUSINESS_RESOURCE_ORDER.map((slug) => {
          const r = BUSINESS_RESOURCES[slug];
          if (!r) return null;
          return (
            <Link
              key={slug}
              to={`/business/${slug}`}
              className="ty-stat"
              style={{ textDecoration: 'none', borderLeftColor: '#7980ff' }}
            >
              <div className="ty-stat__label">{r.icon} {r.label}</div>
              <div className="ty-stat__value" style={{ fontSize: 18, color: '#31394f' }}>
                Manage →
              </div>
              <div className="ty-stat__weekly">{r.singular} CRUD</div>
            </Link>
          );
        })}
        {BUSINESS_STATIC_TILES.map((tile) => (
          <Link
            key={tile.key}
            to={tile.to}
            className="ty-stat"
            style={{ textDecoration: 'none', borderLeftColor: '#7980ff' }}
          >
            <div className="ty-stat__label">{tile.icon} {tile.label}</div>
            <div className="ty-stat__value" style={{ fontSize: 18, color: '#31394f' }}>
              Manage →
            </div>
            <div className="ty-stat__weekly">{tile.subtitle}</div>
          </Link>
        ))}
      </div>
    </>
  );
}
